import { gql } from '@apollo/client';

export const MUTATION_ADD_C2C_VEHICLE = gql`
  mutation AddC2cVehicle($input: C2cVehicleInput) {
    addC2cVehicle(input: $input) {
      garageVehicleId
      sku
      vehicleId
      status
    }
  }
`;

export const MUTATION_DELETE_C2C_VEHICLE = gql`
  mutation DeleteC2cVehicle($c2cId: String!) {
    deleteC2cVehicle(c2cId: $c2cId)
  }
`;

export const MUTATION_CONTACT_C2C = gql`
  mutation ContactC2c($c2cId: String!, $input: C2cContactInput) {
    contactC2c(c2cId: $c2cId, input: $input)
  }
`;
